<div class="flex-column-center">
	<div class="row">
		<h3 i18n="renameDeviceGroup-renameGroup" class="font-size-18">Rename Group</h3>
		<div class="margin-left-8 font-size-18">| {{ data.deviceGroupData.group.name }}</div>
	</div>
	<mat-divider></mat-divider>

	<mat-dialog-content>
		@if (showMessage) {
			<div>
				<mat-form-field subscriptSizing="dynamic" appearance="outline" class="new-group-name-input">
					<mat-label i18n="@@renameDeviceGroup-newGroupName">New Group Name</mat-label>
					<input matInput [formControl]="nameInput" data-automation-id="new-group-name-input" />
				</mat-form-field>
			</div>
		}

		@if (loading) {
			<div class="align-center div-flex-column">
				<mat-spinner diameter="37" class="align-center spinner"></mat-spinner>
			</div>
		}

		@if (showError && !loading) {
			<div class="error-message">
				<div i18n="renameDeviceGroup-errorUpdatingGroupName">
					Error updating the device group name. Please try again.
				</div>
			</div>
		}
	</mat-dialog-content>

	@if (!loading) {
		<mat-dialog-actions class="row-right">
			<button
				class="secondary-small-button"
				(click)="onCancelClicked()"
				i18n="renameDeviceGroup-cancel"
				data-automation-id="rename-device-group-dialog-cancel-button"
			>
				Cancel
			</button>
			@if (showMessage) {
				<button
					class="primary-small-button"
					(click)="onConfirmClicked()"
					i18n="renameDeviceGroup-updateName"
					[disabled]="!nameInput.valid || nameInput.value?.trim() === ''"
					data-automation-id="rename-device-group-dialog-confirm-button"
				>
					Update Name
				</button>
			}
		</mat-dialog-actions>
	}
</div>
